import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ClaimTypeAutomationRule.Save.IRequest;
type Response = Api.Core.ClaimTypeAutomationRule.Save.IResponse;
type Headers = Api.Core.ClaimTypeAutomationRule.Save.IHeaders;
const url = '/api/Claims/ClaimTypeAutomationRule';
export default async function claimTypeAutomationRuleSaveApi(body: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
